import { render, staticRenderFns } from "./ThgMyVehicleThgQuoteDetail.vue?vue&type=template&id=818035d2"
import script from "./ThgMyVehicleThgQuoteDetail.vue?vue&type=script&lang=ts"
export * from "./ThgMyVehicleThgQuoteDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports